import React, { useState, useEffect } from "react";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import { makeStyles, withStyles } from "@mui/styles";
import Button from "components/CustomButtons/Button.js";
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { automationText } from "variables/MBM/geb";
import { controltypeData, controllistData } from "variables/MBM/lists/equipments";
import styles from "assets/jss/material-dashboard-pro-react/views/chartsStyle";
import tablestyles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { NotificationManager } from "react-notifications";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import AutomationDialog from "./AutomationDialog";
import { getGEBAutomations, deleteGEBAutomation, putGEBAutomation, getSchedules, getGEBScripts } from "services/ConfigServices";
import axios from "axios";
import UserService from "services/UserService";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import AutomationStartDialog from "./AutomationStartDialog";
import CustomConfirmationButton from "components/CustomButtons/CustomConfirmationButton.js";
import moment from "moment";
import { automationtypeData } from "variables/MBM/lists/geb";

const DialogContent = withStyles((theme) => ({
    root: {
        padding: '16px',
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: '8px',
    },
}))(MuiDialogActions);
const cardHeaderStyle = {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: "space-between",
    alignItems: "center",
    flexDirection: 'row',
    flexWrap: 'nowrap',
};
const menuButtonStyle = {
    float: "right",
    position: "relative",
    marginRight: "0",
    paddingTop: "0",
    paddingBottom: "0px",
    paddingRight: "2px",
    paddingLeft: "2px",
    fontFamily: '"Source Sans Pro",sans-serif',
    color: "#000000",
    background: "transparent",
    boxShadow: "none",
};
const useStylesTable = makeStyles(tablestyles);
const useStyles = makeStyles(styles);
const useStyles2 = makeStyles((theme) => ({
    planicon: {
        display: 'block',
        position: 'absolute',
        cursor: 'pointer',
        background: '#ffffffd6',
        borderRadius: 10,
    },
    planicongreen: {
        display: 'block',
        position: 'absolute',
        cursor: 'pointer',
        color: "#91C73C",
        background: '#ffffffd6',
        borderRadius: 10,
    },
    planmenu: {
        display: 'flex',
        aligItems: "flex-end",
    },
    plansubmenu: {
        display: 'flex',
        marginTop: 7,
        marginLeft: 5,
    },
    planmenuicon: {
        width: "20px",
        height: "20px",
        marginLeft: "1px",
        marginTop: "1px",
    },
    planmenubutton: {
        background: "#FFFFFF"
    },
    planmenubuttonpressed: {
        background: "#91C73C"
    },
    planmenubuttonfspressed: {
        background: "#9798A0"
    },
    "@keyframes flicker": {
        from: {
            opacity: 1
        },
        to: {
            opacity: 0.8
        }
    },
    flicker: {
        animationName: "$flicker",
        animationDuration: "2000ms",
        animationIterationCount: "infinite",
        animationDirection: "alternate",
        animationTimingFunction: "ease-in-out"
    },
    withAnimation: ({ disabled }) => ({
        animationPlayState: disabled ? "paused" : "running"
    })
}));
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: ${(props) => props.marginleft};
`;
const ExpandableElementColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-left: ${(props) => props.marginleft};
`;
const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;
const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;
const ElementSubData = styled.div`
  margin-left: 12px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;
const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const setNotification = (status, text) => {
    if (status === "success") {
        NotificationManager.success(text);
    } else {
        NotificationManager.error(text);
    }
};
export default function AutomationWidget(props) {
    const currentusertype = localStorage.getItem('userType');
    const permis = JSON.parse(localStorage.getItem("permission")) || [];
    const mbm_geb_control_schedules = permis.includes("mbm_geb_control_schedules");
    const mbm_geb_control_admin_override = permis.includes("mbm_geb_control_admin_override");
    const classes = useStyles();
    const classes2 = useStyles2();
    const tableclasses = useStylesTable();
    const { editionmode, points, iots, equipments, workspace, fullpoints } = props;
    const [openMenu, setOpenMenu] = useState(false);
    const [openAutomation, setOpenAutomation] = useState(false);
    const [openStartAutomation, setOpenStartAutomation] = useState(false);
    const [automations, setAutomations] = useState([]);
    const [currentAutomation, setCurrentAutomation] = useState();
    const [automationEvent, setAutomationEvent] = useState();
    const [schedulesData, setSchedulesData] = useState([]);
    const [scriptData, setScriptData] = useState([]);

    useEffect(() => {
        getAutomations();
    }, [workspace]);


    useEffect(() => {
        if (workspace.idgroup > 0) {
            axios
                .get(
                    getSchedules(workspace.idgroup),
                    {
                        headers: {
                            Authorization: `Bearer ${UserService.getToken()}`,
                        },
                    }
                )
                .then((res) => {
                    let tmpSchedulesData = res.data.schedules?.map((data) => {
                        return (
                            { name: data.parameters.name, id: data.id, destination: data.destination }
                        );
                    });
                    setSchedulesData(tmpSchedulesData || []);
                });
            axios
                .get(
                    getGEBScripts(workspace.id),
                    {
                        headers: {
                            Authorization: `Bearer ${UserService.getToken()}`,
                        },
                    }
                )
                .then((res) => {
                    let tmpScriptData = res.data.scripts?.map((data) => {
                        return (
                            { name: data.parameters.name, id: data.id, destination: data.destination }
                        );
                    });
                    setScriptData(tmpScriptData || []);
                });
        }
    }, [workspace.idgroup]);


    const getAutomations = () => {
        axios
            .get(
                getGEBAutomations(workspace.id),
                {
                    headers: {
                        Authorization: `Bearer ${UserService.getToken()}`,
                    },
                }
            )
            .then((res) => {
                setAutomations(res.data.automations || []);
            })
            .catch(() => { });
    }

    const isinoverride = (row) => {
        let inoverride = false;
        if (row.event && row.event.begin && row.event.end) {
            if (moment(row.event.begin).isSameOrBefore(moment()) && moment(row.event.end).isSameOrAfter(moment()))
                inoverride = true;
        }
        return inoverride;
    }

    const isafteroverride = (row) => {
        let afteroverride = false;
        if (row.event && row.event.begin && row.event.end) {
            if (moment(row.event.end).isBefore(moment()))
                afteroverride = true;
        }
        return afteroverride;
    }

    const isbeforeoverride = (row) => {
        let beforeoverride = false;
        if (row.event && row.event.begin && row.event.end) {
            if (moment(row.event.begin).isAfter(moment()))
                beforeoverride = true;
        }
        return beforeoverride;
    }

    const conditionalRowStyles = [
        {
            when: row => (row.status === 1 && isinoverride(row)),
            style: {
                backgroundColor: '#91c241',
            },
            classNames: [classes2.flicker]
        },
    ];

    const ExpandableComponent = props => {
        const { data } = props;
        const classes = useStyles2();
        let eqcount = 0;
        let controltype = '';
        let ac = 0;

        const SubTabs = () => {
            return (
                <>
                    <div>
                        <ExpandableElement>
                            <ElementTitle>{automationText.description} : </ElementTitle>
                            <ElementData>{data.parameters?.description}</ElementData>
                        </ExpandableElement>
                        <ExpandableElementColumn>
                            <ElementTitle>{automationText.actions} : </ElementTitle>
                            {
                                data.parameters?.actions.map((action) => {

                                    return (
                                        <>
                                            <ElementData>{(action.actiondesc || automationText.emptydesc) + " - " + action.targetequipments?.length + automationText.selectedequipments}</ElementData>
                                        </>)
                                })
                            }
                            {/* {
                                data.parameters?.actions.map((action) => {

                                    return (
                                        <>
                                            <ElementData>{automationText.controltype + " : " + controltypeData.find((ctd) => ctd.id === action.controltype)?.name || ''}</ElementData>
                                            <ElementSubData>{automationText.selectedequipmentstitle + " : " + action.targetequipments?.length}</ElementSubData>
                                            {
                                                action.controlmode && action.controlmode == 1 ?
                                                    <>
                                                        {action.changeschedule ? <ElementSubData>{automationText.defaultschedule} : {action.schedule ? schedulesData.find((sch) => sch.id === action.schedule)?.name : ""}</ElementSubData> : <></>}
                                                        {action.changeformula ? <ElementSubData>{automationText.defaultformula} : {action.formula || ""}</ElementSubData> : <></>}</> :
                                                    <>
                                                        <ElementSubData>{automationText.defaultval} : {controltypeData.find((ctd) => ctd.id === action.controltype)?.type === 'list' ?
                                                            controllistData.find((cld) => cld.id === action.defaultval)?.name :
                                                            (action.defaultval + controltypeData.find((ctd) => ctd.id === action.controltype)?.unit || "")}</ElementSubData>
                                                    </>
                                            }

                                        </>)
                                })
                            } */}
                        </ExpandableElementColumn>
                        {
                            data.parameters.automationtype === "derogation" ?
                                <>
                                    <ElementTitle>{automationText.triggers} : </ElementTitle>
                                    {
                                        data.parameters?.triggers?.map((trigger) => {

                                            return (
                                                <>
                                                    <ElementData>{trigger.triggerdesc || automationText.emptydesc}</ElementData>
                                                </>)
                                        })
                                    }
                                </>
                                : <></>

                        }

                        {/* {
                            (data.status === 1 && !isafteroverride(data)) ?
                                <>
                                    <ExpandableElement>
                                        <ElementTitle>{automationText.automationdatebegin} : </ElementTitle>
                                        <ElementData>{data.event.begin && moment(data.event.begin).isValid()
                                            ? moment(data.event.begin).format("DD/MM/YYYY HH:mm")
                                            : ""}
                                        </ElementData>
                                    </ExpandableElement>
                                    <ExpandableElement>
                                        <ElementTitle>{automationText.automationdateend} : </ElementTitle>
                                        <ElementData>{data.event.end && moment(data.event.end).isValid()
                                            ? moment(data.event.end).format("DD/MM/YYYY HH:mm")
                                            : ""}
                                        </ElementData>
                                    </ExpandableElement>
                                    <ExpandableElementColumn>
                                        <ElementTitle>{automationText.actions} : </ElementTitle>
                                        {
                                            data.event?.actions?.map((action) => {

                                                return (
                                                    <>
                                                        <ElementData>{automationText.controltype + " : " + controltypeData.find((ctd) => ctd.id === action.controltype)?.name || ''}</ElementData>
                                                        <ElementSubData>{automationText.selectedequipmentstitle + " : " + action.targetequipments?.length}</ElementSubData>
                                                        {
                                                            action.controlmode && action.controlmode == 1 ?
                                                                <>
                                                                    {action.changeschedule ? <ElementSubData>{automationText.defaultschedule} : {action.schedule ? schedulesData.find((sch) => sch.id === action.schedule)?.name : ""}</ElementSubData> : <></>}
                                                                    {action.changeformula ? <ElementSubData>{automationText.defaultformula} : {action.formula || ""}</ElementSubData> : <></>}</> :
                                                                <>
                                                                    <ElementSubData>{automationText.automationval} : {controltypeData.find((ctd) => ctd.id === action.controltype)?.type === 'list' ?
                                                                        controllistData.find((cld) => cld.id === action.val)?.name :
                                                                        (action.val + controltypeData.find((ctd) => ctd.id === action.controltype)?.unit || "")}</ElementSubData>
                                                                </>
                                                        }

                                                    </>)
                                            })
                                        }
                                    </ExpandableElementColumn>
                                </>

                                : <>
                                </>
                        } */}
                        {/* {
                            (data.parameters.automationtype === "controlrule" && data.event) ?
                                <>
                                    <ExpandableElement>
                                        <ElementTitle>{automationText.lastlauch} : </ElementTitle>
                                        <ElementData>{data.event.date && moment(data.event.date).isValid()
                                            ? moment(data.event.date).format("DD/MM/YYYY HH:mm")
                                            : ""}
                                        </ElementData>
                                    </ExpandableElement>
                                    <ExpandableElementColumn>
                                        <ElementTitle>{automationText.lastactions} : </ElementTitle>
                                        {
                                            data.event?.actions?.map((action) => {

                                                return (
                                                    <>
                                                        <ElementData>{automationText.controltype + " : " + controltypeData.find((ctd) => ctd.id === action.controltype)?.name || ''}</ElementData>
                                                        <ElementSubData>{automationText.selectedequipmentstitle + " : " + action.targetequipments?.length}</ElementSubData>
                                                        {
                                                            action.controlmode && action.controlmode == 1 ?
                                                                <>
                                                                    {action.changeschedule ? <ElementSubData>{automationText.defaultschedule} : {action.schedule ? schedulesData.find((sch) => sch.id === action.schedule)?.name : ""}</ElementSubData> : <></>}
                                                                    {action.changeformula ? <ElementSubData>{automationText.defaultformula} : {action.formula || ""}</ElementSubData> : <></>}</> :
                                                                <>
                                                                    <ElementSubData>{automationText.automationval} : {controltypeData.find((ctd) => ctd.id === action.controltype)?.type === 'list' ?
                                                                        controllistData.find((cld) => cld.id === action.val)?.name :
                                                                        (action.val + controltypeData.find((ctd) => ctd.id === action.controltype)?.unit || "")}</ElementSubData>
                                                                </>
                                                        }

                                                    </>)
                                            })
                                        }
                                    </ExpandableElementColumn>
                                </>

                                : <>
                                </>
                        } */}

                    </div>

                </>
            );
        };
        return (
            <Container>
                <ExpandableContainer>
                    <div>
                        <SubTabs />
                    </div>
                </ExpandableContainer>
            </Container>
        );
    };

    const automationsColumns = [
        {
            name: automationText.name,
            selector: (row) => row.parameters.name,
            sortable: true,
            // maxWidth: "12rem",
            cell: (row) => row.parameters.name,
            compact: true,
        },
        {
            name: automationText.type,
            selector: (row) => row.parameters.automationtype ? automationtypeData.find((aut) => aut.id === row.parameters.automationtype).name : "",
            sortable: true,
            width: "6rem",
            cell: (row) => row.parameters.automationtype ? automationtypeData.find((aut) => aut.id === row.parameters.automationtype).name : "",
            compact: true,
        },
        {
            name: automationText.lastlauch,
            selector: (row) => row.event?.date ? moment(row.event.date).format("DD/MM/YYYY HH:mm") : "",
            sortable: true,
            width: "6rem",
            cell: (row) => row.event?.date ? moment(row.event.date).format("DD/MM/YYYY HH:mm") : "",
            compact: true,
        },
        // {
        //     name: automationText.automationdatebegin,
        //     selector: (row) => (row.status === 1 && !isafteroverride(row)) ? row.event.begin : "",
        //     sortable: true,
        //     maxWidth: "10rem",
        //     cell: (row) => (row.status === 1 && !isafteroverride(row)) ? moment(row.event.begin).format("DD/MM/YYYY HH:mm") : "",
        // },
        {
            name: "",
            compact: true,
            sortable: false,
            width: "9rem",
            right: true,
            // eslint-disable-next-line react/button-has-type
            // eslint-disable-next-line react/display-name
            cell: (row) => (
                <>
                    <div className="actions-right">
                        {(currentusertype == 1 || mbm_geb_control_admin_override) &&
                            <>
                                {(!row.status || row.status !== 1 || isafteroverride(row)) ?
                                    <>
                                        <Tooltip title={automationText.startautomation}>
                                            <Button
                                                onClick={launchAutomation(row)}
                                                color={"success"}
                                                className={tableclasses.actionButtonDense}
                                            >
                                                <PlayArrowIcon fontSize="large" />
                                            </Button>
                                        </Tooltip>
                                        {editionmode &&
                                            <>
                                                <Tooltip title={automationText.editautomation}>
                                                    <Button
                                                        onClick={editAutomation(row)}
                                                        color={"warning"}
                                                        className={tableclasses.actionButtonDense}
                                                    >
                                                        <EditIcon fontSize="large" />
                                                    </Button>
                                                </Tooltip>
                                                <Tooltip title={automationText.delautomation}>
                                                    <CustomDeleteButton
                                                        deleteTitle={automationText.delautomation}
                                                        deleteSubTitle={automationText.confirmdelautomation + row.parameters.name + '?'}
                                                        handleSupprimer={deleteAutomation(row)}
                                                        size={"28px"}
                                                    />
                                                </Tooltip>
                                            </>
                                        }
                                    </>
                                    :

                                    <CustomConfirmationButton
                                        dialogtitle={automationText.stopautomation}
                                        subTitle={automationText.confirmstopautomation}
                                        confirmation={automationText.confirmyes}
                                        icon={<StopIcon fontSize="large" />}
                                        tooltip={automationText.stopautomation}
                                        color="danger"
                                        size={"28px"}
                                        handleConfirmation={stopAutomation(row)}
                                    />

                                }

                            </>
                        }
                    </div>
                </>
            ),
        }
    ]



    const launchAutomation = (row) => async () => {
        let obj = automations.find((o) => o.id === row.id);
        if (obj) {
            let automationeventtmp = JSON.parse(JSON.stringify(obj));
            setAutomationEvent(automationeventtmp);
            // setCurrentAutomation(obj);
            handleStartAutomation();
        }
    }

    const stopAutomation = (row) => async () => {
        let obj = automations.find((o) => o.id === row.id);
        if (obj) {
            axios
                .put(
                    putGEBAutomation(obj.id, "stop"),
                    {

                    },
                    {
                        headers: {
                            Authorization: `Bearer ${UserService.getToken()}`,
                            "Content-Type": "application/json; charset=utf-8",
                        },
                    }
                )
                .then((res) => {
                    if (res.status == 200) {
                        NotificationManager.success(automationText.automationstoped);
                        refetch();
                    } else NotificationManager.error("Une erreur est survenue");
                })
                .catch((error) => {
                    NotificationManager.error("Une erreur est survenue");
                    // setLoading(false);
                });
        }
    }
    const editAutomation = (row) => async () => {
        let obj = automations.find((o) => o.id === row.id);
        if (obj) {
            setCurrentAutomation(obj);
            setOpenAutomation(true);
        }
    }
    const deleteAutomation = (row) => async () => {
        let obj = automations.find((o) => o.id === row.id);
        if (obj) {
            let url = deleteGEBAutomation(obj.id);
            axios
                .delete(url,
                    {
                        headers: {
                            Authorization: `Bearer ${UserService.getToken()}`,
                        },
                    })
                .then((res) => {
                    if (res.status == 200) {
                        setNotification(
                            "success",
                            automationText.delautomationconfirmed
                        );
                        refetch();
                    } else setNotification("error", "Une erreur est survenue");
                })
                .catch((error) => {
                    setNotification("error", "Une erreur est survenue");
                });
        }
    };

    const handleCloseMenu = (event) => { setOpenMenu(null) };
    const handleClickMenu = (event) => { setOpenMenu(event.currentTarget) };
    const handleAddAutomation = (event) => {
        setOpenMenu(null);
        setCurrentAutomation();
        setOpenAutomation(true);
    }
    const handleCloseAutomation = (event) => {
        setOpenAutomation(false);
    }
    const handleStartAutomation = (event) => { setOpenStartAutomation(true); }
    const handleCloseStartAutomation = (event) => { setOpenStartAutomation(false); }

    const refetch = (event) => {
        getAutomations();
    }

    return (
        <>
            <Card style={{ marginTop: '10px' }}>
                <CardHeader style={cardHeaderStyle}>
                    <h4 className={classes.cardIconTitleSimpleCard} style={{ marginTop: "0px" }}>{automationText.title}</h4>
                    <div className={classes2.planmenu}>
                        {editionmode ?
                            <>
                                <Button
                                    id="basic-button"
                                    aria-controls={openMenu ? 'basic-menu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={openMenu ? 'true' : undefined}
                                    onClick={handleClickMenu}
                                    style={menuButtonStyle}
                                >
                                    <MenuIcon />
                                </Button>
                                <Menu
                                    id="basic-menu"
                                    anchorEl={openMenu}
                                    open={Boolean(openMenu)}
                                    onClose={handleCloseMenu}
                                    MenuListProps={{
                                        'aria-labelledby': 'basic-button',
                                    }}
                                >
                                    <MenuItem onClick={handleAddAutomation} key={`handleaddplan`}>
                                        {automationText.menuaddautomation}
                                    </MenuItem>
                                </Menu>
                            </>
                            : <></>
                        }
                    </div>
                </CardHeader>
                <CardBody>
                    <DataTable
                        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                        noDataComponent={<NoData>{"Aucun équipement"}</NoData>}
                        noHeader={true}
                        columns={automationsColumns}
                        persistTableHead
                        pagination
                        dense
                        data={automations}
                        expandOnRowClicked
                        expandableRows
                        expandableRowsComponent={ExpandableComponent}
                        paginationComponentOptions={{
                            noRowsPerPage: true,
                            rowsPerPageText: "Lignes par page",
                            rangeSeparatorText: "sur",
                            selectAllRowsItem: false,
                            selectAllRowsItemText: "Selectionner toutes les lignes",
                        }}
                        selectableRows={false}
                        defaultPageSize={10}
                        defaultSortFieldId={1}
                        manual={true}
                        conditionalRowStyles={conditionalRowStyles}
                    />
                </CardBody>
            </Card>
            <Dialog
                onClose={handleCloseAutomation}
                aria-labelledby="addMarket-dialog-title"
                fullWidth={true}
                maxWidth="md"
                open={openAutomation}
            >
                <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseAutomation}>
                    {automationText.automation}
                </CustomDialogTitle>
                <DialogContent dividers>
                    <AutomationDialog
                        closeModal={handleCloseAutomation}
                        refetch={refetch}
                        equipments={equipments}
                        fullpoints={fullpoints}
                        workspace={workspace}
                        currentAutomation={currentAutomation}
                        schedulesData={schedulesData}
                        scriptData={scriptData}
                    />
                </DialogContent>
                <DialogActions />
            </Dialog>
            <Dialog
                onClose={handleCloseStartAutomation}
                aria-labelledby="addMarket-dialog-title"
                fullWidth={true}
                maxWidth="sm"
                open={openStartAutomation}
            >
                <CustomDialogTitle id="addMarket-dialog-title" onClose={handleCloseStartAutomation}>
                    {automationText.startautomation}
                </CustomDialogTitle>
                <DialogContent dividers>
                    <AutomationStartDialog
                        closeModal={handleCloseStartAutomation}
                        refetch={refetch}
                        fullpoints={fullpoints}
                        automation={automationEvent}
                        schedulesData={schedulesData}
                        scriptData={scriptData}
                    />
                </DialogContent>
                <DialogActions />
            </Dialog>
        </>
    );
}